import { getAuthToken } from './get-auth-token'
import type { FetchOptions } from './interface'

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' // Métodos HTTP válidos

interface FetchOptionsInput {
  method: HttpMethod // Aseguramos que solo se usen métodos válidos
  body?: any // `body` es opcional
  headers?: Record<string, string>
}

export const fetchOptions = async ({ method, body, headers }: FetchOptionsInput) => {
  const { accessToken, idToken, role, strapiId } = await getAuthToken()

  // if (!idToken) {
  //   throw new Error('No hay token de autenticación disponible')
  // }

  const options: FetchOptions = {
    method, // Restringido al tipo HttpMethod
    headers: {
      Authorization: `Bearer ${idToken}`,
      'role': role as string,
      'strapi-user-id': strapiId as string,
      'x-access-token': accessToken as string,
      'Content-Type': 'application/json',
      ...(headers || {})
    },
    ...(body ? { body: body } : {}) // Incluimos `body` solo si existe
  }

  return options
}
